import { useMemo, useRef } from 'react';
import { ValidationLevel, ValidationProps } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Configuration } from 'app/components/metro-line/types';
import { ImportSetAdminTranslation } from '../../constants';
import { ImportSetItemValidation } from '../types-store';
import { ImportSetSectionType } from './types';
import { ImportSetActionType } from 'app/area/import-sets-administration/form/types';

const isValid = (validationProps: ValidationProps[], level: ValidationLevel) =>
  !validationProps.some(prop => (prop?.messages?.length ?? 0) > 0 && prop?.level === level);

export const getImportSetRoute = (
  actionType: ImportSetActionType,
  id: number,
  section?: ImportSetSectionType
) => actionType && {
  [ImportSetActionType.add]: routeConstants.importSetAddFor(section),
  [ImportSetActionType.codelikecode]: routeConstants.importSetCodeLikeCodeFor(section),
  [ImportSetActionType.duplicate]: routeConstants.importSetDuplicateFor(id, section),
  [ImportSetActionType.edit]: routeConstants.importSetEditFor(id, section)
}[actionType]

export const importSetConfiguration = (
  actionType: ImportSetActionType,
  id: number,
  validationErrors: ImportSetItemValidation
): Configuration<ImportSetSectionType>[] => {

  const detailsSectionRef = useRef<HTMLDivElement | null>(null);
  const translationsSectionRef = useRef<HTMLDivElement | null>(null);

  return useMemo(() => {

    const getSectionRoute = (section: ImportSetSectionType) => getImportSetRoute(actionType, id, section);

    const renderLanguageOnTop = !isDefinedIncludingZero(id) || actionType === ImportSetActionType.duplicate;
    const languageSection = {
      section: ImportSetSectionType.Translations,
      visible: true,
      url: getSectionRoute(ImportSetSectionType.Translations),
      iconUrl: '/i/case-sections/actions.svg',
      label: (translation: ImportSetAdminTranslation) => translation.descriptions_and_translations,
      ref: translationsSectionRef,
      isValid: isValid([validationErrors.language], ValidationLevel.error)
    };

    return [
      ...(renderLanguageOnTop ? [languageSection] : []),
      {
        section: ImportSetSectionType.Details,
        visible: true,
        iconUrl: '/i/case-sections/default.svg',
        url: getSectionRoute(ImportSetSectionType.Details),
        label: (translation: ImportSetAdminTranslation) => translation.details,
        ref: detailsSectionRef,
        isValid: isValid([
          validationErrors.importDatabaseId, validationErrors.disabled,
          validationErrors.criteriaDomain, validationErrors.importConstraintSet
        ], ValidationLevel.error)
      },
      ...(!renderLanguageOnTop ? [languageSection] : [])
    ];
  }, [id, actionType, detailsSectionRef, translationsSectionRef, validationErrors]);
};
